import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'ActionUserInput',
})(({ brandColors, spacing, breakpoints }) => ({
  container: {
    padding: `${spacing(5)} 0`,
    background: `linear-gradient(188deg, ${brandColors.offWhite} 3.24%, ${brandColors.chargeBlue} 110.59%)`,
  },
  contentContainer: {
    paddingBottom: spacing(3),
  },
  textContentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  subheading: {
    marginTop: spacing(1),
    color: brandColors.tintsNeutral20,
  },
  bulletedList: {
    marginTop: spacing(3),
  },
  footer: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  footerText: { whiteSpace: 'nowrap' },
  footerLink: {
    textDecoration: 'underline',
    marginLeft: spacing(0),
    color: brandColors.mediumBlue,
    whiteSpace: 'nowrap',
    fontWeight: 500,
    '&:hover': {
      color: brandColors.primaryMain,
    },
  },
  leadForm: {
    marginTop: spacing(4),
    [breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
}));

export default useStyles;
